import { BlockType, CreateBlockType, DragBlockType } from "../../../types/block/type";

const clientOnlyFields: Array<keyof BlockType> = [
  "id",
  "gcalId",
  "creator",
  "createdAt",
  "updatedAt",
  "subBlocks",
  "previewNote",
  "displayOrder",
  "itemLastStatus",
  // calendar 전체 필드는 삭제하고, calendarId만 남겨두어 이전,이후 캘린더 값을 비교해 반영한다.
  "calendar",
  "completedAt",
];

const recurringOnlyFields: Array<keyof BlockType> = ["originalId", "originalStart"];

export const removeClientOnlyFields = (
  blockData: BlockType,
  isRecurringBlock: boolean
): CreateBlockType => {
  const filteredData = { ...blockData };

  clientOnlyFields.forEach((field) => {
    delete filteredData[field];
  });

  if (!isRecurringBlock) {
    recurringOnlyFields.forEach((field) => {
      delete filteredData[field];
    });
  }

  return { ...filteredData };
};

// NOTE: drag시 추가되는 필드 제거

const dragItemOnlyFields: Array<keyof DragBlockType> = [
  "dragType",
  "sourceResource",
  "kind",
  "color",
  "index",
];

export const removeDragOnlyFields = (blockData: DragBlockType): BlockType => {
  const filteredData = { ...blockData };

  dragItemOnlyFields.forEach((field) => {
    delete filteredData[field];
  });

  return filteredData;
};
